<template>
	<ul class="chat-rooms-list">
		<li v-for="tab in state.roomTabs" @click="selectRoom(tab.target)" :class="{active: state.activeTab == tab.target}">
			<span
				class="title flex-auto"
				:title="tab.name"
				>{{ tab.name }}<template v-if="tab.unread > 0"> ({{ tab.unread }})</template></span>
			<svg-icon
				v-if="!tab.joined"
				@click.native="reconnectToRoom($event, tab.target)"
				class="chat-button-reconnect"
				title="Переподключиться к комнате"
				height="16"
				fill="#fb0"
				name="lightning"
				/>
			<img
				@click="closeRoomTab($event, tab.target)"
				class="chat-button-close"
				src="/assets/i/delete.png"
				title="Покинуть комнату"
				/>
		</li>
	</ul>
</template>

<script>
import eventBus from '../eventbus';
import SvgIcon from './SvgIcon';

export default {
	components: {
		SvgIcon,
	},

	data(){
		return {
			state: eventBus.state,
		};
	},

	methods: {
		closeRoomTab(e, target) {
			e.preventDefault();
			eventBus.$emit('closeRoomTab', target);
		},

		selectRoom(target) {
			eventBus.$emit('selectRoom', target);
			setTimeout(() => this.$emit('scrollToEnd'), 0);
		},

		reconnectToRoom(e, target) {
			e.preventDefault();
			eventBus.$emit('joinRoom', target);
		},
	}
}
</script>

<style lang="less" scoped>
@import (reference) "~@/css/chat.less";

.chat-rooms-list {
	display: block;
	padding: 0;
	margin: 0;

	> li {
		display: flex;
		flex-direction: row;
		align-items: center;

		list-style: none;
		margin: 0 0 5px 0;
		padding: 8px;
		border-radius: 2px;
		cursor: pointer;

		.title {
			overflow: hidden;
		}

		&.active {
			background-color: @color-chat-6;

			&:hover {
				background-color: @color-chat-6;
			}
		}

		&:hover {
			background-color: @color-chat-5;
		}

		> .chat-button-close {
			flex: none;
			height: 10px;
		}

		> .chat-button-reconnect {
			flex: none;
			margin-right: 5px;
			height: 16px;
		}
	}
}
</style>
